import { useState } from 'react';

export default function useWafToken() {
  const [token, setToken] = useState(null);

  window.AwsWafIntegration?.getToken().then(tok => setToken(tok));

  return { token };
}
